export default __webpack_public_path__ + "static/media/alumni_banner.8123f2a2.jpg";